import { XdrSearchResultsPanelController } from '../controller/XdrSearchResultsPanelController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';

export class XdrSearchResultsPanelWebComponent extends BaseWebComponentElement {
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: XdrSearchResultsPanelController,
    });
  }
}
